export const DEFAULT_VALUE = 'defaultValue';
export const ENABLED = 'enabled';
export const REQUIRED = 'required';